// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.info-content {
  font-size: 14px;
  max-height: 0px !important;
  text-align: center;
  overflow: hidden;
  transition: max-height 0.2s ease-out;
}
.info-content .col {
  opacity: 0;
  transition: 1s;
}
.info-content .close-btn {
  position: absolute;
  top: 8px;
  right: 8px;
}
.info-content .user-details h2, .info-content .user-details h3 {
  font-weight: 400;
}
.info-content .user-details p {
  font-size: 13px;
}
.info-content img {
  border-radius: 50%;
  width: 130px;
  height: 130px;
}
.info-content.show {
  max-height: 500px !important;
  transition: max-height 0.2s ease-in;
}
.info-content.show .col {
  opacity: 1;
}
.info-content.show img, .info-content.show .close-btn {
  animation: scale 0.6s ease-out;
}
.info-content.has-bg-image {
  background-image: url('header-bg.6c5262d2bca37239.png');
  background-blend-mode: overlay;
  background-size: 300px;
}
.info-content .top-contact-form {
  border-style: solid;
  border-width: 0 1px;
}
.info-content .top-contact-form form {
  max-width: 280px;
  margin: 0 auto;
}
.info-content .controls {
  width: 120px;
  margin: 0 auto;
}
@keyframes scale {
  5% {
    transform: scale(0.5);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
}
@media screen and (min-width: 960px) {
  .info-content.has-bg-image {
    background-size: 480px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/theme/components/top-info-content/top-info-content.component.scss"],"names":[],"mappings":"AAGA;EACI,eAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,oCAAA;AAFJ;AAGI;EACI,UAAA;EACA,cAAA;AADR;AAGI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;AADR;AAIQ;EACI,gBAAA;AAFZ;AAIQ;EACI,eAAA;AAFZ;AAKI;EACI,kBAAA;EACA,YAAA;EACA,aAAA;AAHR;AAKI;EACI,4BAAA;EACA,mCAAA;AAHR;AAIQ;EACI,UAAA;AAFZ;AAIQ;EAGI,8BAAA;AAFZ;AAKI;EACI,uDAAA;EACA,8BAAA;EACA,sBAAA;AAHR;AAKI;EACI,mBAAA;EACA,mBAAA;AAHR;AAIQ;EACI,gBAAA;EACA,cAAA;AAFZ;AAKI;EACI,YAAA;EACA,cAAA;AAHR;AA+BA;EACI;IACI,qBAAA;EANN;EAQE;IACI,qBAAA;EANN;EAQE;IACI,mBAAA;EANN;AACF;AAUA;EACI;IACI,sBAAA;EARN;AACF","sourcesContent":["// ==========================================================================\r\n// Component: Top-info-content.component\r\n// ==========================================================================\r\n.info-content{\r\n    font-size: 14px;\r\n    max-height: 0px !important;\r\n    text-align: center;\r\n    overflow: hidden;\r\n    transition: max-height 0.2s ease-out;\r\n    .col{\r\n        opacity: 0;\r\n        transition: 1s;\r\n    }\r\n    .close-btn{\r\n        position: absolute;\r\n        top: 8px;\r\n        right: 8px;\r\n    }\r\n    .user-details{\r\n        h2, h3{\r\n            font-weight: 400;\r\n        }\r\n        p{\r\n            font-size: 13px;\r\n        }\r\n    }\r\n    img{\r\n        border-radius: 50%;\r\n        width: 130px;\r\n        height: 130px;\r\n    }\r\n    &.show{\r\n        max-height: 500px !important;\r\n        transition: max-height 0.2s ease-in;\r\n        .col{\r\n            opacity: 1;\r\n        }\r\n        img, .close-btn{\r\n            -webkit-animation: scale 0.6s ease-out;\r\n            -moz-animation: scale 0.6s ease-out;\r\n            animation: scale 0.6s ease-out;\r\n        }\r\n    }\r\n    &.has-bg-image{\r\n        background-image: url(\"../../../../assets/img/app/header-bg.png\");\r\n        background-blend-mode: overlay;\r\n        background-size: 300px; \r\n    }\r\n    .top-contact-form{        \r\n        border-style: solid;\r\n        border-width: 0 1px;\r\n        form{\r\n            max-width: 280px;\r\n            margin: 0 auto;\r\n        }\r\n    }\r\n    .controls{\r\n        width: 120px;\r\n        margin: 0 auto;\r\n    }\r\n    \r\n}\r\n\r\n\r\n@-moz-keyframes scale { \r\n    5% {\r\n        -moz-transform: scale(0.5);\r\n    }\r\n    50% {\r\n        -moz-transform: scale(1.2);\r\n    }\r\n    100% {\r\n        -moz-transform: scale(1);\r\n    } \r\n}\r\n@-webkit-keyframes scale { \r\n    5% {\r\n        -webkit-transform: scale(0.5);\r\n    }\r\n    50% {\r\n        -webkit-transform: scale(1.1);\r\n    }\r\n    100% {\r\n        -webkit-transform: scale(1);\r\n    } \r\n}\r\n@keyframes scale { \r\n    5% {\r\n        transform: scale(0.5);\r\n    }\r\n    50% {\r\n        transform: scale(1.1);\r\n    }\r\n    100% {\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n\r\n@media screen and (min-width: 960px) {    \r\n    .info-content.has-bg-image{\r\n        background-size: 480px;         \r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
